import { get, post, put, patch } from "../Config"

export function SearchInvestorFile({ params = {}, lang }) {
  return get({ url: `/v1/admin/investor-file`, params, lang })
}
export function GetInvestorFileById({ id, lang }) {
  return get({ url: `/v1/admin/investor-file/${id}`, lang })
}
export function CreateInvestorFile({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/investor-file`, params, data, lang })
}
export function UpdateInvestorFile({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/investor-file/${id}`, params, data, lang })
}
export function PatchInvestorFile({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/investor-file/${id}`, params, data, lang })
}
export function DeleteInvestorFile({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/investor-file/mutiDelete`, params, data, lang })
}
